import { ITranslations } from 'types/common';
import { TableActionsButtonsTransFields } from './types';
import en from 'translations/en/tableActionsButtons.json';
import pl from 'translations/pl/tableActionsButtons.json';
import sl from 'translations/sl/tableActionsButtons.json';

export const tableActionsButtonsTranslations: ITranslations<TableActionsButtonsTransFields> = {
  name: 'tableActionsButtons',
  en,
  pl,
  sl,
};
